import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  margin-left: 8px;
  width: 380px;
  max-height: 60vh;
  display: flex;
  flex-direction: column;
  padding: 15px;

  background: #fff;
  border: 1px solid #d8e0eb;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(23, 38, 59, 0.18);
  z-index: 10;
`;

export const Header = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #eef2f7;
`;

export const Title = styled.strong`
  display: flex;
  font-size: 16px;
  border-bottom: 2px solid #ececec;
`;

export const Field = styled.div`
  margin-top: 10px;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 12px;
  color: #7a8aa0;
`;

export const Select = styled.select`
  width: 100%;
  margin-top: 4px;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #d8e0eb;
  font-size: 13px;
`;

export const Body = styled.div`
  flex: 1;
  padding: 12px 16px;
  overflow-y: auto;
`;

export const ItemBase = styled.div`
  margin-bottom: 12px;
  padding: 10px;
  background: #ececec;
  border-radius: 8px;
`;

export const ItemBaseLabel = styled.span`
  font-size: 12px;
  color: #7a8aa0;
`;

export const ItemBaseDesc = styled.div`
  font-size: 14px;
  font-weight: 800;
`;

export const ItemBasePn = styled.div`
  font-size: 12px;
  font-weight: 800;
  color: #4a5568;
`;

export const ListLabel = styled.span`
  font-size: 12px;
  color: #7a8aa0;
`;

export const List = styled.div`
  margin-top: 6px;
`;

export const EmptyMessage = styled.div`
  padding: 8px 0;
  font-size: 13px;
  color: #7a8aa0;
`;

export const ItemRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #f3f5f8;
  cursor: pointer;
`;

export const Checkbox = styled.input`
  margin-top: 3px;
`;

export const ItemInfo = styled.span``;

export const ItemDesc = styled.span`
  font-size: 13px;
  font-weight: 600;
`;

export const ItemPn = styled.span`
  display: block;
  font-size: 12px;
  color: #4a5568;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 15px;
  border-top: 1px solid #eef2f7;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.7;
    cursor: default;
  }
`;

export const CancelButton = styled(Button)`
  background: #eef2f7;
  color: #4a5568;
`;

export const ConfirmButton = styled(Button)`
  background: #ff6d3c;
  color: #fff;
`;
